import React, { Component } from "react";
import "./styles/styles.css";
import "./styles/OnBoarding.css";
import Main from "./containers/MainContainer";
import { connect } from "react-redux";
import { FlagsProvider } from "@lectra/ld-react-feature-flags";
import { DEFECT_KEY } from "./store/defect";
import { ThemeProvider } from "@mui/material/styles";
import { lectraMuiTheme, MuiGuidedTourProvider, SupportedLocale } from "@lectra/mui-library";

const REACT_APP_LAUNCHDARKLY_CLIENTKEY =
  window.process !== undefined
    ? window.process.env.REACT_APP_LAUNCHDARKLY_CLIENTKEY
    : process.env.REACT_APP_LAUNCHDARKLY_CLIENTKEY;

function mapStateToProps(state) {
  const isConnected = state.authentication[DEFECT_KEY] == null;

  if (isConnected) {
    return {
      isConnected,
      flagProviderConf: {
        user: {
          key: state.authentication.email,
          custom: {
            tenantId: state.authentication.tenantId,
          },
        },
        clientkey: REACT_APP_LAUNCHDARKLY_CLIENTKEY,
      },
      locale: state.locale,
    };
  } else {
    return {
      isConnected,
    };
  }
}

class App extends Component {
  render() {
    let locale = this.props.locale === undefined || this.props.locale === "" ? SupportedLocale.EN : this.props.locale;

    if (this.props.isConnected)
      return (
        <ThemeProvider theme={lectraMuiTheme}>
          <FlagsProvider {...this.props.flagProviderConf} loadingComponent={<div>please wait</div>}>
            <MuiGuidedTourProvider
              lang={locale}
              disableInteractions
              onClose={() => {
                var img1 = document.getElementById("DownloadImg");
                img1.classList.remove("tourDownloadConversionListShow");
                img1.classList.add("tourDownloadConversionListHide");

                var img2 = document.getElementById("ViewPaternAssistant");
                img2.classList.remove("whatisnewViewPaternAssistantShow");
                img2.classList.add("whatisnewViewPaternAssistantHide");

                var img3 = document.getElementById("ViewPAConversion");
                img3.classList.remove("tourViewPAConversionListShow");
                img3.classList.add("tourViewPAConversionListHide");
              }}
            >
              <Main connected="true"></Main>
            </MuiGuidedTourProvider>
          </FlagsProvider>
        </ThemeProvider>
      );
    else return <Main connected="false" />;

    {
    }
  }
}

export default connect(mapStateToProps)(App);
